import { GameWrapper } from '@repo/core-phaser-wrapper';
import { StatePlugin } from '@repo/plugin-state';
import { SignalsPlugin } from '@repo/plugin-signals';
import { SplashScene, PreloaderScene } from '@repo/scene-preloader';
import { TimeTrackerPlugin } from '@repo/plugin-timetracker';
import { GameScene } from './scenes/GameScene';

/**
 * Unequal (Futoshiki) Game
 *
 * A logic puzzle game where you fill an N×N grid with numbers 1 to N,
 * following Latin square rules and inequality/adjacency constraints.
 */

// Create game wrapper with feature flags
const wrapper = new GameWrapper(
  // Game-specific scenes
  [GameScene],

  // Game configuration
  {
    width: 900,
    height: 700,
    // backgroundColor: '#1a1a2e',
    backgroundColor: 'transparent',
    parent: 'game-container',
    debug: false,
  },

  // Feature flags - enable the features you want
  {
    splash: true, // Show splash screen
    preloader: true, // Show loading screen
    highscore: false, // Scoreboard is now a modal in UI package
    raffle: false, // Disable raffle
    api: false, // Disable API
    analytics: false, // Disable analytics
    pauseOnLostFocus: true, // Auto-pause when tab/window loses focus
  },

  // Dependencies - plugins and scenes for enabled features
  {
    StatePlugin,
    SignalsPlugin,
    SplashScene,
    PreloaderScene,
    TimeTrackerPlugin,
  }
);

// Initialize the game
const game = wrapper.initialize();

// Configure game registry (for preloader)
game.registry.set('firstGameScene', 'GameScene');
game.registry.set('gameName', 'Unequal');
game.registry.set('assetManifest', {
  // No external assets needed
  images: [],
  spritesheets: [],
  audio: [],
  json: [],
});

// Export for debugging
(window as unknown as { game: Phaser.Game }).game = game;
(window as unknown as { wrapper: GameWrapper }).wrapper = wrapper;

console.log('Unequal (Futoshiki) initialized!');
console.log('Features enabled:', {
  splash: true,
  preloader: true,
  pauseOnLostFocus: true,
});
console.log('Controls:');
console.log('  - Arrow keys: Move selection');
console.log('  - 1-N: Fill number (or toggle pencil mark with Shift)');
console.log('  - Delete/0: Clear cell');
console.log('  - M: Auto-fill pencil marks');
console.log('  - H: Get hint');
console.log('  - P: Toggle pencil mode');
